module.exports = __webpack_public_path__ + "static/img/third2_3_active.cdd22e48.png";